var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoClearFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74322 0.29068C10.082 0.62447 10.0861 1.16971 9.75229 1.50851L1.4746 9.91035C1.14081 10.2491 0.595574 10.2532 0.256777 9.91942C-0.08202 9.58563 -0.0860787 9.04039 0.247711 8.70159L8.5254 0.299746C8.85919 -0.0390512 9.40443 -0.04311 9.74322 0.29068Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.256777 0.29068C0.595574 -0.04311 1.14081 -0.0390512 1.4746 0.299746L9.75229 8.70159C10.0861 9.04039 10.082 9.58563 9.74322 9.91942C9.40443 10.2532 8.85919 10.2491 8.5254 9.91035L0.247711 1.50851C-0.0860787 1.16971 -0.08202 0.62447 0.256777 0.29068Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClearFilter);
export default __webpack_public_path__ + "static/media/ico_clear_filter.f9def8fbec59373a38cce8058a40df87.svg";
export { ForwardRef as ReactComponent };